module.exports = __webpack_public_path__ + "static/img/activity2_2.b5bc24d5.png";